import React, { useMemo } from 'react'
import { DesktopTick, Header, MobileTick, TickList, Wrapper } from './GiftingCallout.styles'
import Icon from './Icons'
import { Body } from '@big-red-group/storefront-common-ui'
import { ProductSession } from '@big-red-group/storefront-common-checkout'

const GiftingCallout: React.FC<{ sessions: ProductSession[] }> = ({ sessions }) => {
  const getCommonPgp = (sessions: ProductSession[]): number | undefined | null => {
    const firstPgp = sessions[0]?.pgp
    return sessions.every((session) => session.pgp === firstPgp) ? firstPgp : undefined
  }

  const pgp = useMemo(() => getCommonPgp(sessions), [sessions])
  const mobileItems: string[] = [
    '5 year validity',
    pgp ? `${pgp} month price guarantee` : 'Price guarantee period',
    'Free Exchanges',
  ]
  const desktopItems: string[] = [
    'Valid for 5 years',
    pgp
      ? `Price locked for peace of mind with our ${pgp} month guarantee`
      : 'Price locked for peace of mind with our price guarantee period',
    'Exchangeable for free for any preferred experience',
  ]

  return (
    <Wrapper>
      <Header>
        <Icon name="gift" />
        <Body weight="bold" size="M">
          Buy as a gift
        </Body>
      </Header>
      <Body>When you buy as a voucher, your recipient can book a date that suits them. All experience vouchers are:</Body>
      <TickList>
        {mobileItems.map((item, index) => (
          <MobileTick key={index}>
            <Body>{item}</Body>
          </MobileTick>
        ))}
        {desktopItems.map((item, index) => (
          <DesktopTick key={index}>
            <Body>{item}</Body>
          </DesktopTick>
        ))}
      </TickList>
    </Wrapper>
  )
}

export default GiftingCallout
